var map = {
	"./bronze1.png": 5554,
	"./bronze2.png": 3201,
	"./bronze3.png": 1414,
	"./bronze4.png": 8773,
	"./bronze5.png": 2313,
	"./gold1.png": 1627,
	"./gold2.png": 3640,
	"./gold3.png": 9832,
	"./gold4.png": 5875,
	"./gold5.png": 6619,
	"./marvel health hero.png": 9122,
	"./platinum1.png": 3020,
	"./platinum2.png": 2117,
	"./platinum3.png": 5507,
	"./platinum4.png": 372,
	"./platinum5.png": 2112,
	"./silver1.png": 1937,
	"./silver2.png": 3014,
	"./silver3.png": 8361,
	"./silver4.png": 9287,
	"./silver5.png": 8857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 913;